var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5151 13.9442C18.9674 12.8522 19.2002 11.6819 19.2002 10.5C19.2002 8.11305 18.252 5.82387 16.5642 4.13604C14.8763 2.44821 12.5871 1.5 10.2002 1.5C7.81325 1.5 5.52406 2.44821 3.83623 4.13604C2.14841 5.82387 1.2002 8.11305 1.2002 10.5C1.2002 11.6819 1.43299 12.8522 1.88528 13.9442C2.33757 15.0361 3.00051 16.0282 3.83623 16.864C4.67196 17.6997 5.66411 18.3626 6.75604 18.8149C7.84797 19.2672 9.0183 19.5 10.2002 19.5C11.3821 19.5 12.5524 19.2672 13.6443 18.8149C14.7363 18.3626 15.7284 17.6997 16.5642 16.864C17.3999 16.0282 18.0628 15.0361 18.5151 13.9442Z",
    fill: "#003A8C",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 10.5L9.2002 12.5L13.2002 8.5M19.2002 10.5C19.2002 11.6819 18.9674 12.8522 18.5151 13.9442C18.0628 15.0361 17.3999 16.0282 16.5642 16.864C15.7284 17.6997 14.7363 18.3626 13.6443 18.8149C12.5524 19.2672 11.3821 19.5 10.2002 19.5C9.0183 19.5 7.84797 19.2672 6.75604 18.8149C5.66411 18.3626 4.67196 17.6997 3.83623 16.864C3.00051 16.0282 2.33757 15.0361 1.88528 13.9442C1.43299 12.8522 1.2002 11.6819 1.2002 10.5C1.2002 8.11305 2.14841 5.82387 3.83623 4.13604C5.52406 2.44821 7.81325 1.5 10.2002 1.5C12.5871 1.5 14.8763 2.44821 16.5642 4.13604C18.252 5.82387 19.2002 8.11305 19.2002 10.5Z",
    stroke: "#096DD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckComplete);
export default __webpack_public_path__ + "static/media/check_complete.f4a5d98b6a452d9e913b7bee88de0a85.svg";
export { ForwardRef as ReactComponent };